//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";

// custom pages
import { mpcDetailStyles } from "./styles";
import MPCApi from "apis/mpc/mpc";
import masterbenefit from "apis/contractCode/contractCode";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import { useTranslation } from 'react-i18next';
// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function ViewShipTo(props) {
  const { state, dispatch } = useContext(Context);
  const { getDetail, update, getDetailpma } = masterbenefit();
  const history = useHistory();
  const location = useLocation();
  const classes = mpcDetailStyles();
  const [mpc, setMpc] = useState({});
  const [data, setData] = useState();
  const [dataClone, setDataClone] = useState({});
  const [updated, setUpdated] = useState({});
  const [edit, setEdit] = useState(false);
  const { t, i18n } = useTranslation();
  const [dataPma, setDataPma] = useState([]);

  const [sysloyalty, setSysLoyalty] = useState();

  const [datacontract, setDataContract] = useState([]);

  const [pmaedit, SetPmaEdit] = useState("");
  const [ccedit, SetCcEdit] = useState("");
  const [twoValues, SetTwoValues] = useState(false);





  // setting mpc details
  // useEffect(() => {
  //   if (location.state && location.state.mpc) {
  //     setMpc(location.state.mpc);
  //     return;
  //   } else {
  //     history.goBack();
  //   }
  // }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "CONTRACT CODE"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (location?.state?.mpcId) {
      handleGet();
      return;
    }
    history.goBack();
  }, []);
  useEffect(() => {
    // if (typeof data?.loyalty == 'boolean' && typeof data?.system_managed == 'boolean') {
      handleGetpma();
    // }
  }, [data?.pma_type,edit]);
  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.mpcId;
      let res = await getDetail(id);
      if (res) {
        handleGetpma(res?.data)
        setData(res?.data);
        setDataClone(res?.data);
      }
    } catch (e) {
      console.log({ e });
    }
  };
  const handleGetpma = async (values) => {
    try {
      let arg = {};


      let sm = values ? values?.system_managed : data?.system_managed
      let lt = values ? values?.loyalty : data?.loyalty



      // if ((sm == true && lt == true) || (sm == false && lt == false)) {


        arg = { system_managed: sm, loyalty: lt, type: 'update', id: data?.shipto };
        if (updated?.pma_type || data?.pma_type) {
          arg = { ...arg, pma_type: data?.pma_type }
          // delete updated.contract_code;



        }



        let res = await getDetailpma(arg);
        if (res) {
          setDataPma(res?.pmaData);


          if (res?.contractCode) {
            let arrayvalue = res?.contractCode
            let arrayvaluesysandloy = res?.contractCodesysandloy






            if (arrayvalue && arrayvalue.length > 0) {
             
              setDataContract(arrayvalue)
              SetTwoValues(true)

  //  console.log(!sysloyalty,'sysloyalty',!(sysloyalt)
              // if (!sysloyalty) {
                // setData({ ...data, loyalty: arrayvaluesysandloy?.loyalty, system_managed: arrayvaluesysandloy?.system_managed })

              // }



            }



          }
        }
        return

      // }
      // SetPmaEdit(data?.pma_type)
      // return

    } catch (e) {
      console.log({ e });
    }
  };

  const handleUpdate = async () => {
    try {
      let arg = {};

      if (typeof updated?.system_managed == "boolean") {
        updated.system_managed = data?.system_managed
        updated.loyalty = data?.loyalty


      }
      if (!(updated?.pma_type)) {
        updated.pma_type = data?.pma_type
      }
      if (!(updated?.contract_code)) {
        updated.contract_code = data?.contract_code
      }
      if (!(typeof updated?.system_managed == "boolean")) {
        updated.loyalty = data?.system_managed
      }
      if (!(typeof updated?.loyalty == "boolean")) {
        updated.loyalty = data?.loyalty
      }
      console.log(updated, data)
      arg = { updated, id: data?.shipto, billto: data?.billto,uniqueID:data?._id };


      let res = await update(arg);
      if (res) {
        setDataClone({ ...dataClone, ...res?.data });
        setEdit(false);
        history.push("/dashboard/upload-success", {
          type: "Data updated in our system successfully.",
        });
        setSysLoyalty(false)
      }
    } catch (e) {
      console.log({ e });
      setSysLoyalty(false)
    }
  };

  let editObj = {
    pma_type: { edit: edit, type: "string" },
    contract_code: { edit: edit, type: "string" },
    loyalty: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "YES" },
        { value: false, label: "NO" },
      ],
    },
    system_managed: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "YES" },
        { value: false, label: "NO" },
      ],
    },
  };

  let nameObj = {
    shipto: "Customer Account Number",
    billto: "Customer Billto Account Number",
    pma_type: "PMA TYPE",
    loyalty: "loyalty",
    system_managed: "System Managed",
    contract_code: "Contract Code",
  };

  let offset = location?.state?.offset;

  return (
    <React.Fragment>
      <Grid container style={{ padding: 10 }}>
        <Grid item xs={6}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.push("/dashboard/contract-code", { offset });
            }}
          >
            {t('Back')}
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('Contract Code')}</div>
        </div>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{'Customer Account Number'}</span> :{" "}
            {data?.shipto}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Customer Billto Account Number')}</span> :{" "}
            {data?.billto}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Loyalty Id')}</span> :{" "}
            {data?.loyalty_id}
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('Contract Code  Details')}</div>
        </div>
        <Grid xs={12} lg={6} className={classes.grid}>
          {editObj["contract_code"]?.edit ? (
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["contract_code"]}&nbsp;:&nbsp;
                </span>
              </Grid>
              <Grid item xs={8}>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.contract_code}
                  onChange={(e) => {
                    let sys=datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value?.toLowerCase().startsWith('t')?true:false
                    if(e.target.value?.toLowerCase()=='p2b' ||  e.target.value?.toLowerCase() =='p1b'){
                      setData({ ...data,pma_type:e.target.value, contract_code: e.target.value,system_managed:datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value?.toLowerCase().startsWith('t')?true:false,loyalty:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value?.toLowerCase().startsWith('t')?true:false  });
                      setUpdated({ ...updated, contract_code: e.target.value,pma_type:e.target.value});
                      SetCcEdit(e.target.value)
                      

                    } else{
                      if(data?.pma_type?.toLowerCase()=='p2b' ||  e.target.value?.toLowerCase() =='p1b'){
                        setData({ ...data, pma_type:null,contract_code: e.target.value,system_managed:datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value?.toLowerCase().startsWith('t')?true:false,loyalty:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value?.toLowerCase().startsWith('t')?true:false  });
                      setUpdated({ ...updated, contract_code: e.target.value ,pma_type:null});
                      SetCcEdit(e.target.value)
                        
                      }else{
                        if(data?.pma_type?.length>1 &&sys){
                          setData({ ...data, pma_type:null,contract_code: e.target.value,system_managed:datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value?.toLowerCase().startsWith('t')?true:false,loyalty:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value?.toLowerCase().startsWith('t')?true:false  });
                        setUpdated({ ...updated, contract_code: e.target.value,pma_type:null });
                        SetCcEdit(e.target.value)
                        }else{
                          setData({ ...data, contract_code: e.target.value,system_managed:datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value?.toLowerCase().startsWith('t')?true:false,loyalty:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value?.toLowerCase().startsWith('t')?true:false  });
                        setUpdated({ ...updated, contract_code: e.target.value });
                        SetCcEdit(e.target.value)

                        }
                        
                      }
                      
                    }
                  
                  }}
                >
                  {datacontract?.map((r, i) => (
                    <MenuItem value={r?.contract_code} key={i}>
                      {t(r?.contract_code)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span className={classes.gridSpan}>{t('Contract Code')} </span> :{" "}
              </Grid>
              <Grid item xs={8}>
                {data?.contract_code ? data?.contract_code : "-"}
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          {editObj["pma_type"]?.edit ? (
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["pma_type"]}&nbsp;:&nbsp;
                </span>
              </Grid>
              <Grid item xs={8}>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.pma_type}
                  onChange={(e) => {
                    let sys=datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value?.toLowerCase().startsWith('t')?true:false

                    if( e.target.value?.toLowerCase() =='p2b' ||  e.target.value?.toLowerCase() =='p1b'){
                      setData({ ...data, pma_type: e.target.value,contract_code: e.target.value,system_managed:datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value?.toLowerCase().startsWith('t')?true:false,loyalty:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value?.toLowerCase().startsWith('t')?true:false  });
                      setUpdated({ ...updated, pma_type: e.target.value,contract_code: e.target.value ,system_managed:datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed?datacontract.find(obj=>obj.contract_code==e.target.value)?.system_managed:e.target.value?.toLowerCase().startsWith('t')?true:false,loyalty:datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty?datacontract.find(obj=>obj.contract_code==e.target.value)?.loyalty:e.target.value?.toLowerCase().startsWith('t')?true:false  });
                      SetPmaEdit(e.target.value)
                      setSysLoyalty(false)

                    }else{
                      if(data?.contract_code?.toLowerCase()=='p2b' ||  e.target.value?.toLowerCase() =='p1b'){
                        setData({ ...data, pma_type: e.target.value,contract_code:null });
                        setUpdated({ ...updated, pma_type: e.target.value ,contract_code:null});

                      }else{
                        if(data?.loyalty &&  e.target.value?.length>1){
                          setData({ ...data, pma_type: e.target.value,contract_code:null });
                          setUpdated({ ...updated, pma_type: e.target.value,contract_code:null });

                        }else{
                          setData({ ...data, pma_type: e.target.value });
                          setUpdated({ ...updated, pma_type: e.target.value });
                        }
                     

                      }
                     
                      SetPmaEdit(e.target.value)
                      setSysLoyalty(false)
                    }
                   

                  }}
                >
                  {dataPma?.map((r, i) => (
                    <MenuItem value={r?.pma_type} key={i + 1}>
                      {t(r?.pma_type)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
             </Grid>
          ) : (
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span className={classes.gridSpan}>{t('PMA TYPE')} </span> :{" "}
              </Grid>
              <Grid item xs={8}>
                {data?.pma_type ? data?.pma_type : "-"}
              </Grid>
            </Grid>
          )}
        </Grid>
     
        <Grid container xs={12} lg={6} className={classes.grid}>
          {/* {(editObj["loyalty"]?.edit && typeof data?.loyalty) == 'boolean' ? (
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["loyalty"]}&nbsp;:&nbsp;
                </span>
              </Grid>
              <Grid item xs={8}>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.loyalty}
                  onChange={(e) => {
                    setData({ ...data, loyalty: e.target.value });
                    setUpdated({ ...updated, loyalty: e.target.value });
                    setSysLoyalty(true)
                  }}
                >
                  {editObj["loyalty"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid>
          ) : ( */}
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span className={classes.gridSpan}>{t('Loyalty')} </span> :{" "}
              </Grid>
              <Grid item xs={8}>
                {data?.loyalty == true ? (
                  <span className={classes.activeSpan}>{t('YES')}</span>
                ) : data?.loyalty == false ? (
                  <span className={classes.inActiveSpan}>{t('NO')}</span>
                ) : "-"}
              </Grid>
            </Grid>
          {/* // )} */}
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
      
          {/* {(editObj["system_managed"]?.edit && typeof data?.system_managed == 'boolean') ? (
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["system_managed"]}&nbsp;:&nbsp;
                </span>
              </Grid>
              <Grid item xs={8}>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.system_managed}
                  onChange={(e) => {
                    setData({ ...data, system_managed: e.target.value });
                    setUpdated({ ...updated, system_managed: e.target.value });
                    setSysLoyalty(true)
                  }}
                >
                  {editObj["system_managed"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid>
          ) : ( */}
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span className={classes.gridSpan}>{t('System Managed')} </span> :{" "}
              </Grid>
              <Grid item xs={8}>
                {data?.system_managed == true ? (
                  <span className={classes.activeSpan}>{t('YES')}</span>
                ) : data?.system_managed == false ? (
                  <span className={classes.inActiveSpan}>{t('NO')}</span>
                ) : "-"}
              </Grid>
            </Grid>
          {/* )} */}
        </Grid>
      
        {/* <Grid xs={12} lg={6} className={classes.grid}>
          {editObj["contract_code"]?.edit ? (
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["contract_code"]}&nbsp;:&nbsp;
                </span>
              </Grid>
              <Grid item xs={8}>
                <CssTextField
                  fullWidth
                  variant="outlined"
                  className={classes.cssTextField}
                  disabled={!edit}
                  value={data?.contract_code}
                  onChange={(e) => {

                    setData({
                      ...data,
                      contract_code: (e.target.value).toUpperCase(),
                    });
                    setUpdated({
                      ...updated,
                      contract_code: (e.target.value).toUpperCase(),
                    });
                  }}
                />
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <span className={classes.gridSpan}>{t('Contract Code')} </span> :{" "}
              </Grid>
              <Grid item xs={8}>
                {data?.contract_code}
              </Grid>
            </Grid>
          )}
        </Grid> */}
        <Grid xs={12} lg={6} className={classes.grid}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <span className={classes.gridSpan}>{t('Privilege Code')} </span> :{" "}
            </Grid>
            <Grid item xs={8}>
              {data?.privilege_code ? data?.privilege_code : "-"}
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={12} lg={6} className={classes.gridBtn}></Grid>
        <Grid xs={12} lg={6} className={classes.gridBtn}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <Button
                className={classes.editBtn}
                onClick={() => {
                 
                  if (state?.userInfo?.editAction) {
                    if (edit) {
                      console.log(updated,"updated")
                      if (updated && Object.keys(updated).length > 0) {
                        if(!data?.contract_code){
                          return toast.error("Please Choose Contract Code");
                        }
                        if(!data?.pma_type){
                          return toast.error("Please Choose PMA Type");
                        }
                        if (updated?.pma_type) {
                          if (updated?.pma_type == data?.pma_type) {
                            if (updated?.contract_code || data?.contract_code) {
                              handleUpdate()
                              return
                            }
                            return toast.error("Please Choose Contract Code");
                          }
                          if (updated?.contract_code) {
                            handleUpdate()
                            return
                          }
                          return toast.error("Please Choose Contract Code");
                        }
                        if (typeof updated?.system_managed == 'boolean' || typeof updated?.loyalty == 'boolean') {

                          let sm = updated?.system_managed ? updated?.system_managed: data?.system_managed
                          let lt = updated?.loyalty ? updated?.loyalty : data?.loyalty
                          if ((sm == true && lt == true) || (sm == false && lt == false)) {
                            handleUpdate()
                          } else {
                            return toast.error("System Managed and Loyalty should be same");
                          }

                          if (updated?.pma_type || data?.pma_type) {
                            if (updated?.contract_code || data?.contract_code) {
                              handleUpdate()
                              return
                            }
                            return toast.error("Please Choose Contract Code");
                          }
                          return toast.error("Please Choose PMA Type and  Contract Code");

                        }
                        if (updated && Object.keys(updated).length > 0) {
                          handleUpdate()
                          return;
                        }
                        return toast.error("Edit atleast one field.", {
                          toastId: "update-btn",
                        });

                      }

                      toast.error("Edit atleast one field.", {
                        toastId: "update-btn",
                      });
                    } else {
                      setEdit(true);
                      setUpdated({ ...data,system_managed:datacontract?.find(obj=>obj.contract_code== data?.contract_code)?.system_managed?datacontract.find(obj=>obj.contract_code== data?.contract_code)?.system_managed: data?.contract_code?.toLowerCase().startsWith('t')?true:false,loyalty:datacontract.find(obj=>obj.contract_code== data?.contract_code)?.loyalty?datacontract.find(obj=>obj.contract_code== data?.contract_code)?.loyalty: data?.contract_code?.toLowerCase().startsWith('t')?true:false});

                      //console.log((datacontract.find(obj=>obj.contract_code== data?.contract_code)?.system_managed?datacontract.find(obj=>obj.contract_code== data?.contract_code)?.system_managed: data?.contract_code?.toLowerCase().startsWith('t')?true:false)===data?.system_managed,"neww",data?.contract_code)
                      if((datacontract.find(obj=>obj.contract_code== data?.contract_code)?.system_managed?datacontract.find(obj=>obj.contract_code== data?.contract_code)?.system_managed: data?.contract_code?.toLowerCase().startsWith('t')?true:false)!=data?.system_managed){
                      if(data && data?.contract_code){
                        setUpdated({ ...data,system_managed:datacontract?.find(obj=>obj.contract_code== data?.contract_code)?.system_managed?datacontract.find(obj=>obj.contract_code== data?.contract_code)?.system_managed: data?.contract_code?.toLowerCase().startsWith('t')?true:false,loyalty:datacontract.find(obj=>obj.contract_code== data?.contract_code)?.loyalty?datacontract.find(obj=>obj.contract_code== data?.contract_code)?.loyalty: data?.contract_code?.toLowerCase().startsWith('t')?true:false});
                        

                        setData({ ...data,system_managed:datacontract?.find(obj=>obj.contract_code== data?.contract_code)?.system_managed?datacontract.find(obj=>obj.contract_code== data?.contract_code)?.system_managed: data?.contract_code?.toLowerCase().startsWith('t')?true:false,loyalty:datacontract.find(obj=>obj.contract_code== data?.contract_code)?.loyalty?datacontract.find(obj=>obj.contract_code== data?.contract_code)?.loyalty: data?.contract_code?.toLowerCase().startsWith('t')?true:false  });
    

                      }
                       

                      }
 
                     
                    }
                    return;
                  }
                  else {
                    toast.error(state.userInfo?.editAccess)
                    return;
                  }
                }}
              // disabled={!access['editAccess'][state.userInfo?.role]['mpcdetail']}
              >
                {edit ? "Update" : "Edit"}
              </Button>
            </Grid>
            <Grid item xs={4}>
              {edit && (
                <Button
                  className={classes.editCancelBtn}
                  onClick={() => {
                    setData(dataClone);
                    setEdit(false);
                    setDataPma([])
                    setDataContract([])
                    SetPmaEdit("")
                    SetCcEdit("")
                    delete updated.pma_type;
                    delete updated.contract_code;
                  }}
                >
                  {t('cancel')}
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
